import { Search, X } from "lucide-react";
import { Input } from "snap-design-system";
import { forwardRef } from "react";

export interface SearchInputProps {
  value: string;
  placeholder?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  onClear: () => void;
  className?: string;
  disabled?: boolean;
  "data-testid"?: string;
}

export const SearchInput = forwardRef<HTMLInputElement, SearchInputProps>(
  (
    {
      value,
      placeholder = "Procurar",
      onChange,
      onKeyDown,
      onClear,
      className = "",
      disabled = false,
      "data-testid": dataTestId,
    },
    ref
  ) => {
    return (
      <Input
        ref={ref}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        onKeyDown={onKeyDown}
        disabled={disabled}
        icon={value ? <X size={18} /> : <Search size={18} />}
        iconPosition="right"
        onIconClick={value ? onClear : undefined}
        maxLength={100}
        fullWidth
        className={className}
        data-testid={dataTestId}
        aria-label={value ? "Limpar busca" : "Buscar"}
      />
    );
  }
);

SearchInput.displayName = "SearchInput";
